import { gql } from '@apollo/client'
import { getAnomalyQuery } from './anomaly-summary-query.js'
import { getSupplierDollarShareQuery } from './supplier-dollar-share-query.js'
import { apolloClientDS } from '../../../apollo.js'

export const getAnomalyDetectionQuery = () => {
    const query = `query anomalySummary($startDate: String!, $endDate: String!, $hierarchyArr: [String] ) {
        ${getAnomalyQuery()}
        ${getSupplierDollarShareQuery()}
    }`
    return query;
}

export const generateAnomalyDetectionQuery = (payload) => {
    const queryStr = gql `${getAnomalyDetectionQuery()}`;
    const query = queryStr;

    return apolloClientDS.query({
        query,
        context: {
			headers: {
				'x-Apollo-operation-name': "anomalySummary"
			}
		},
        variables: payload
    })

}

